export type User = {
    email: string
    exp: number
    iat: number
    isSubscribed: boolean
    stripeSubscriptionId: string
    userId: number
    subscriptionType: 'REGULAR' | 'PREMIUM' | 'ENTERPRISE' | null
}

export type AuthStore = {
    // State
    currentUser: User
    token: string
    fmpApiKey: string | null

    // Actions
    setAuth: (token: string) => void
    setFMPApiKey: (fmpApiKey: string) => void
    logout: () => void
}

// Initial state for auth
export const AUTH_INITIAL_STATE: User = {
    email: '',
    exp: 0,
    iat: 0,
    isSubscribed: false,
    stripeSubscriptionId: '',
    userId: 0,
    subscriptionType: null,
}
